/**
 * @generated SignedSource<<1b3e2f0db74a7e90927db6232a914c53>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type FlyPreviewStatus = "RUNNING" | "STOPPED" | "STARTING" | "DEGRADED" | "%future added value";
export type StopFlyPreviewInput = {
  slug: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type StopFlyPreviewMutation$variables = {
  input: StopFlyPreviewInput;
};
export type StopFlyPreviewMutation$data = {
  readonly stopFlyPreview: {
    readonly flyPreview: {
      readonly id: string;
      readonly slug: string;
      readonly branchName: string | null;
      readonly webUrl: string;
      readonly status: FlyPreviewStatus;
      readonly machinesTotal: number;
      readonly machinesRunning: number;
      readonly lastUsedAt: string | null;
      readonly lastUsedKnown: boolean;
      readonly createdAt: string | null;
      readonly deployedAt: string | null;
    } | null;
  } | null;
};
export type StopFlyPreviewMutation = {
  variables: StopFlyPreviewMutation$variables;
  response: StopFlyPreviewMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StopFlyPreviewPayload",
    "kind": "LinkedField",
    "name": "stopFlyPreview",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FlyPreview",
        "kind": "LinkedField",
        "name": "flyPreview",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "branchName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "webUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "machinesTotal",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "machinesRunning",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastUsedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastUsedKnown",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deployedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StopFlyPreviewMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StopFlyPreviewMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fd28781ba3b33ef40cf0b6d10bce39f6",
    "id": null,
    "metadata": {},
    "name": "StopFlyPreviewMutation",
    "operationKind": "mutation",
    "text": "mutation StopFlyPreviewMutation(\n  $input: StopFlyPreviewInput!\n) {\n  stopFlyPreview(input: $input) {\n    flyPreview {\n      id\n      slug\n      branchName\n      webUrl\n      status\n      machinesTotal\n      machinesRunning\n      lastUsedAt\n      lastUsedKnown\n      createdAt\n      deployedAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "92fd7f68934b963d25397b694d0e378c";

export default node;
